import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Layout from "./Layout";
import Home from "../pages/Home";
import Work from "../pages/Work";
import { BlogPost } from "../pages/BlogPost";
import Blog from "../pages/Blog";
import { NotFound } from "./NotFound";
import { ThemeProvider } from "./ThemeProvider";
import { ScrollToTop } from "./ScrollToTop";
const App = () => {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="work" element={<Work />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </ThemeProvider>
  );
};

export default App;
